import{gql as e}from"@apollo/client";const r=e`
  mutation updateUserService($services: [ENetfrontService]!, $userIds: [Int]!) {
    user {
      updateUserService(services: $services, userIds: $userIds)
    }
  }
`;export{r as UPDATE_USER_SERVICE_MUTATION};
//# sourceMappingURL=useUpdateUserService.graphql.js.map
